import { useState, useEffect, useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import { FaEdit, FaTrash, FaFile, FaUser } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Server from "../../Shared/Server";
import { API_BASE_URL } from "../../Shared/Server";
import Spinner from '../../Shared/Spinner'
import DataGrid from '../../Shared/DataGrid';

const Employees = () => {
    const [employees, setEmployees] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const [show, setShow] = useState(false);
    const [publicID, setPublicID] = useState()

    const navigate = useNavigate()

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        setIsLoading(true)
        try {
            const response = await Server.get('/employees/')
            setEmployees(response?.data);
            setIsLoading(false);

        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error.response.status === 403){
              toast.error(error.response.data.detail);
              navigate('/');
            }else {
              toast.error(error.response.data)
            }
        }
    }

    const handleClose = () => {
        if (isDeleting) return;
        setShow(false)
    }
    const handleShow = (public_id) => {
        setShow(true)
        setPublicID(public_id)
    };

    const handleDelete = async (public_id) => {
        setIsDeleting(true)
        try {
            const response = await Server.delete(`/employees/${public_id}`)
            toast.success(response.data.detail)
            setEmployees(prev => prev.filter((emp) => emp.public_id !== public_id))
            setShow(false)
        } catch (error) {
            if(error?.response?.status === 401){
                navigate('/login')
            }else if (error?.response?.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else{
                toast.error(error?.response?.data?.detail || 'Failed to delete employee')
            }
        } finally {
            setIsDeleting(false)
        }
    }

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            valueFormatter: function (params) {
                if (isNaN(params.node.id)) {
                    return "";
                }
                return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        { headerName: "Name", field: "full_name" },
        { headerName: "Contact", field: "contact_number" },
        { headerName: "Gender", field: "gender" },
        { headerName: "Status", field: "status" },
        { headerName: "Occupation", field: "ocupation" },
        { headerName: "Responsible", field: "responsible_name" },
        { headerName: "RContact", field: "responsible_contact" },
        { headerName: "Salary", field: "salary" },
        {
            headerName: "Actions",
            pinned: 'left',
            minWidth: 220,
            sortable: false,
            filter: false,
            cellRenderer: (e) => {
                if (!e.data) return null;
                return (
                    <div className="d-flex gap-1">
                        <Link
                            className="btn btn-outline-info"
                            to="/update-employee"
                            state={{ employee: e.data }}
                            title="Edit"
                        >
                            <FaEdit />
                        </Link>
                        <button
                            className="btn btn-outline-danger"
                            onClick={() => handleShow(e.data.public_id)}
                            title="Delete"
                        >
                            <FaTrash />
                        </button>
                        {e.data.contract_path && (
                            <a
                                className="btn btn-outline-orange"
                                href={`${API_BASE_URL}/${e.data.contract_path}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Contract"
                            >
                                <FaFile />
                            </a>
                        )}
                        {e.data.picture_path && (
                            <a
                                className="btn btn-outline-orange"
                                href={`${API_BASE_URL}/${e.data.picture_path}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Picture"
                            >
                                <FaUser />
                            </a>
                        )}
                    </div>
                );
            },
        },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ], []);

    if(isLoading){
        return <Spinner/>
    }

    return (
        <>
            <DataGrid
                title="Employees"
                rowData={employees}
                columnDefs={columnDefs}
                headerActions={
                    <Link to="/add-employee" className="btn btn-outline-info">Add Employee</Link>
                }
            />

            <Modal show={show} onHide={handleClose} backdrop={isDeleting ? 'static' : true}>
                <Modal.Header closeButton={!isDeleting}>
                    <Modal.Title>Delete Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this employee? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={isDeleting}>
                        No
                    </Button>
                    <Button variant="danger" onClick={() => handleDelete(publicID)} disabled={isDeleting}>
                        {isDeleting ? 'Deleting\u2026' : 'Yes, delete'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Employees
